"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUser = void 0;
var flow_1 = __importDefault(require("lodash/flow"));
var getUser_1 = __importDefault(require("./functions/getUser"));
var envelope_1 = require("@fuze/apis-core/dist/envelope");
var injectAsyncArguments_1 = __importDefault(require("@fuze/apis-core/dist/injectAsyncArguments"));
var providers_1 = require("../providers");
var injectArguments = injectAsyncArguments_1.default(providers_1.getUrl, providers_1.getBearerToken, providers_1.getOrigin);
var wrapFoundryFunction = flow_1.default(providers_1.errorInterceptor, injectArguments, envelope_1.extractDataFromEnvelope);
exports.getUser = wrapFoundryFunction(getUser_1.default);
